// src/components/HelpPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import { Youtube, MessageCircle, Mail, ArrowLeft, ExternalLink } from 'lucide-react';
import '../styles/HelpPage.css';
import notebookLmIcon from '../assets/notebooklm-icon.svg';

function HelpPage() {
    // TODO: Replace with actual Youtube Video ID
    const YOUTUBE_VIDEO_ID = 'dM21WmUKEeI';
    const YOUTUBE_EMBED_URL = `https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}`;

    // TODO: Replace with actual NotebookLM URL
    const NOTEBOOK_LM_URL = 'https://notebooklm.google.com/notebook/5b8d8868-cbf1-4fe8-aa56-be3d0a578594?authuser=1';

    return (
        <div className="help-page">
            <header className="help-header">
                <h1 className="help-title">ヘルプ・使い方ガイド</h1>
                <p className="help-subtitle">システムの使い方やよくある質問について</p>
            </header>

            {/* 動画セクション */}
            <section className="help-section">
                <h2 className="section-title">
                    <Youtube className="text-red-500" />
                    概要説明・使い方
                </h2>
                <div className="video-container">
                    <iframe
                        src={YOUTUBE_EMBED_URL}
                        title="System Overview"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>
                <p className="mt-4 text-gray-600 text-sm text-center">
                    システム全体の流れやマッチングの仕組みについて解説しています。
                </p>
            </section>

            {/* NotebookLM セクション */}
            <section className="help-section">
                <h2 className="section-title">
                    <MessageCircle className="text-blue-500" />
                    AIチャットで質問する (NotebookLM)
                </h2>

                <div className="notebook-container">
                    <p className="notebook-description">
                        よくある質問やシステムの詳細仕様については、Google NotebookLM を活用したAIチャットボットで確認できます。
                        「〜〜の場合はどうなりますか？」「〜〜のアルゴリズムは？」など、自由に質問してください。
                    </p>

                    <a
                        href={NOTEBOOK_LM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="notebook-card"
                    >
                        <div className="notebook-icon-wrapper">
                            <img src={notebookLmIcon} alt="NotebookLM" className="notebook-icon" />
                        </div>
                        <div className="notebook-content">
                            <h3 className="notebook-title">NotebookLM で質問する</h3>
                            <p className="notebook-text">AIが公式ドキュメントに基づいて回答します <ExternalLink size={14} className="inline ml-1" /></p>
                        </div>
                    </a>
                </div>
            </section>

            {/* 連絡先 セクション */}
            <section className="help-section">
                <h2 className="section-title">
                    <Mail className="text-green-600" />
                    お問い合わせ・サポート
                </h2>

                <div className="contact-grid">
                    <div className="contact-card">
                        <h3>システム・技術的な問題</h3>
                        <ul className="contact-info">
                            <li>
                                <strong>開発者:</strong> 土屋 奏太
                            </li>
                            <li>
                                <Mail size={16} /> 20m.ka.tsuchiya@gmail.com
                            </li>
                            <li>
                                <MessageCircle size={16} /> LINE (個人的に連絡可)
                            </li>
                        </ul>
                    </div>

                    <div className="contact-card">
                        <h3>運用・ルールに関する相談</h3>
                        <ul className="contact-info">
                            <li>
                                <strong>窓口:</strong> 学年代表
                            </li>
                            <li>
                                直接またはLINE等でご連絡ください。
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="contact-note">
                    <strong>💡 ヒント:</strong> まずは上記の NotebookLM に質問してみてください。それでも解決しない場合や、システムのエラー（画面が動かない等）の場合は、お気軽にご連絡ください。
                </div>
            </section>

            <div className="back-section">
                <Link to="/" className="back-button">
                    <ArrowLeft size={18} />
                    ダッシュボードに戻る
                </Link>
            </div>
        </div>
    );
}

export default HelpPage;
